import React from 'react';
import PropTypes from 'prop-types';

import { NavLink } from 'react-router-dom';

export class Start extends React.Component{

    constructor(props){
        super(props);

        this.onPlayClick = this.onPlayClick.bind(this);
    }
    onPlayClick(){
        
        this.props.onClick();
    }
    render(){
        return(
            <div className="col-sm-4 content">
                <article>
                        <h1>Milloin viimeksi elit koko sydämellä?</h1>
                        <p>
                        Anna mennä vain: tutki maailmaa, venytä rajojasi, heittäydy vauhdin vietäväksi – pyöräytä elämänpyörää ja voit löytää itsesi leffateatterista!
                        </p>
                        
                        {/* Former PlayButton */}
                        <NavLink
                        to={this.props.to}
                        href="#"
                        className="btn btn-green"
                        id="button"
                        style={{display: (this.props.visible ? 'block' : 'none')}}
                        onClick={this.onPlayClick}
                        >
                        {this.props.text}
                        </NavLink>
                </article>
            </div>
        );
    }
}

Start.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};


// WEBPACK FOOTER //
// ./src/app/components/views/Start.js